/* ORO by Etchcraft — product page behaviour (oro-pdp.js) */
(function () {
  'use strict';
  var d = document;
  var details = d.querySelector('.product-details');
  if (!details) return;

  function parseMoney(txt) {
    if (!txt) return NaN;
    var n = txt.replace(/[^\d.,]/g, '').replace(/,/g, '');
    return parseFloat(n);
  }
  function q(sel, root) { return (root || d).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  /* ---------- 1. Savings pill ---------- */
  var savePill = q('[data-oro-save]');
  function updateSavings() {
    if (!savePill) return;
    var sale = q('.product-details .price-item--sale, .product-details .price');
    var cmp = q('.product-details .compare-at-price');
    var s = sale ? parseMoney(sale.textContent) : NaN;
    var c = cmp ? parseMoney(cmp.textContent) : NaN;
    if (isFinite(s) && isFinite(c) && c > s) {
      var pct = Math.round(((c - s) / c) * 100);
      savePill.textContent = 'Save ' + pct + '%';
      savePill.setAttribute('data-visible', 'true');
    } else {
      savePill.setAttribute('data-visible', 'false');
    }
  }
  updateSavings();
  var priceHost = q('.product-details .price-block') || q('.product-details .price');
  if (priceHost && 'MutationObserver' in window) {
    new MutationObserver(function () { setTimeout(updateSavings, 30); })
      .observe(priceHost.closest('.group-block') || priceHost, { subtree: true, childList: true, characterData: true });
  }
  ['variant:update', 'variant:selected'].forEach(function (ev) {
    d.addEventListener(ev, function () { setTimeout(updateSavings, 60); });
  });

  /* ---------- 2. Engraving input + preview (syncs sticky bar + app input) ---------- */
  var box = q('.oro-engrave');
  if (box) {
    var textEl = q('.oro-engrave__text', box);
    var countEl = q('.oro-engrave__count', box);
    var plate = q('.oro-engrave__plate', box);
    var field = q('.oro-engrave__input', box);
    var placeholder = textEl.getAttribute('data-placeholder') || 'Preview appears here';
    var satc = q('#oro-satc-input');
    var appInputSel = 'input[name="properties[Engraving]"]';
    var syncing = false;

    function render(val) {
      val = (val || '').trim();
      textEl.textContent = val || placeholder;
      textEl.classList.remove('is-pop'); void textEl.offsetWidth; if (val) textEl.classList.add('is-pop');
      textEl.setAttribute('data-empty', val ? 'false' : 'true');
      if (countEl) countEl.textContent = val.length + ' / ' + (field.maxLength > 0 ? field.maxLength : 20);
    }
    function push(val) {
      if (syncing) return; syncing = true;
      var app = q(appInputSel);
      if (app && app.value !== val) { app.value = val; app.dispatchEvent(new Event('input', { bubbles: true })); app.dispatchEvent(new Event('change', { bubbles: true })); }
      if (satc && satc.value !== val) { satc.value = val; satc.dispatchEvent(new Event('input', { bubbles: true })); }
      syncing = false;
    }
    field.addEventListener('input', function () { render(field.value); push(field.value); });
    if (satc) satc.addEventListener('input', function () { if (syncing) return; field.value = satc.value; render(field.value); push(field.value); });
    d.addEventListener('input', function (e) {
      if (syncing || !e.target || !e.target.matches || !e.target.matches(appInputSel)) return;
      field.value = e.target.value; render(field.value); push(field.value);
    });

    function activate(attempt) {
      var app = q(appInputSel);
      if (satc || app) {
        box.setAttribute('data-active', 'true');
        var seed = (app && app.value) || (satc && satc.value) || '';
        if (seed) { field.value = seed; render(seed); }
        return;
      }
      if (attempt < 20) setTimeout(function () { activate(attempt + 1); }, 300);
    }
    render(''); activate(0);

    function updateFinish() {
      var sel = qa('.product-details input[type="radio"]:checked').map(function (r) { return (r.value || '').toLowerCase(); }).join(' ');
      var t = (d.title || '').toLowerCase();
      var silver = /silver|steel|platinum|white/.test(sel) || (!/gold|rose/.test(sel) && /silver/.test(t));
      plate.classList.toggle('oro-engrave__plate--silver', !!silver);
    }
    updateFinish();
    d.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') setTimeout(updateFinish, 20); });
  }

  /* ---------- 3. Sticky engraving bar: hide while buy box is visible ---------- */
  var bar = q('#oro-satc');
  var buy = q('.product-details .buy-buttons-block');
  if (bar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var onScreen = entries[0].isIntersecting;
      bar.setAttribute('data-oro-hidden', onScreen ? 'true' : 'false');
    }, { threshold: 0.35 }).observe(buy);
  }

  /* ---------- 4. Story steps reveal (one pass) ---------- */
  var steps = qa('.oro-step');
  if (steps.length && 'IntersectionObserver' in window) {
    var fired = false;
    new IntersectionObserver(function (entries, obs) {
      if (fired || !entries.some(function (e) { return e.isIntersecting; })) return;
      fired = true;
      steps.forEach(function (s, i) { setTimeout(function () { s.classList.add('is-on'); }, 220 * i); });
      obs.disconnect();
    }, { threshold: 0.4 }).observe(steps[0]);
  }

  /* ---------- 5. Motion: buy-box stagger, gallery settle, scroll reveals ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) {
    var probe = q('.oro-engrave') || q('.product-details h1');
    if (probe) {
      var wrap = probe;
      while (wrap.parentElement && wrap.parentElement !== details && wrap.parentElement.children.length < 4) wrap = wrap.parentElement;
      var list = wrap.parentElement ? Array.prototype.slice.call(wrap.parentElement.children) : [];
      list.forEach(function (el, i) { el.style.setProperty('--i', i); el.classList.add('oro-anim'); });
    }
    var gallery = q('media-gallery') || q('.product-information__media') || q('[data-testid="product-information-media"]');
    if (gallery) gallery.classList.add('oro-anim-media');

    var groups = [
      '.oro-story__head', '.oro-spec__item', '.oro-faq details',
      '.product-recommendations .product-card', '.product-recommendations .text-block',
      '.oro_trust, .oro-trust-strip, [class*="oro-trust-strip"]'
    ];
    var revealEls = [];
    groups.forEach(function (sel) {
      qa(sel).forEach(function (el, i) { el.setAttribute('data-oro-reveal', ''); el.style.setProperty('--i', Math.min(i, 7)); revealEls.push(el); });
    });
    if (revealEls.length && 'IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealEls.forEach(function (el) { rio.observe(el); });
      setTimeout(function () { revealEls.forEach(function (el) { el.classList.add('is-in'); }); }, 5000);
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    }
  }
})();
